import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import PhotoUploader from 'components/photos/photo_uploader';
import FloorPlanRow from 'components/floor_plan/floor_plan_row';

const UPLOAD_FLOOR_TEXT = 'Drag or click here to add a plan';

export default function FloorPlan({ floorPlan, onChange }) {
  const dropzoneRef = useRef(null);

  const deletePlan = (e) => {
    e.preventDefault();

    const newFloorPlan = {
      ...floorPlan,
      _destroy: true,
    };

    onChange(newFloorPlan);
  };

  const replacePlan = () => {
    if (dropzoneRef.current) {
      dropzoneRef.current.open();
    }
  };

  const handleUpload = (data) => {
    const newFloorPlan = {
      ...floorPlan,
      thumbnailUrl: data.url,
      uploadId: data.id,
      uploaded: true,
      _destroy: false
    };

    onChange(newFloorPlan);
  };

  const isRowVisible = floorPlan && !floorPlan._destroy;

  return (
    <React.Fragment>
      {/* PhotoUploader needs to be rendered always, otherwise the "Replace Plan" button and the ref will not work
      because the component doesn't exists. */}
      <div className={isRowVisible ? 'hidden' : ''}>
        <PhotoUploader forwardedRef={dropzoneRef} uploadCopy={UPLOAD_FLOOR_TEXT} onUpload={handleUpload} />
      </div>
      {isRowVisible && (
        <FloorPlanRow floorPlan={floorPlan} onDelete={deletePlan} onReplace={replacePlan} />
      )}
    </React.Fragment>
  );
}

FloorPlan.propTypes = {
  floorPlan: PropTypes.shape({
    id: PropTypes.number,
    uploadId: PropTypes.number,
    thumbnailUrl: PropTypes.string
  }),
  onChange: PropTypes.func.isRequired
};
